var mql = window.matchMedia('(max-width: 749px)');
var intervalId;

function handleResize(e) {
  var bar = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__bar');
  if (!bar) return;

  if (e.matches) {
    intervalId = setInterval(function() {
      bar.style.setProperty('left', '20px', 'important');
      bar.style.setProperty('right', '20px', 'important');
      bar.style.setProperty('width', 'calc(100% - 40px)', 'important');
      bar.style.setProperty('transform', 'none', 'important');
    }, 300);
  } else {
    clearInterval(intervalId);
    bar.style.removeProperty('left');
    bar.style.removeProperty('right');
    bar.style.removeProperty('width');
    bar.style.removeProperty('transform');
  }
}

mql.addEventListener('change', handleResize);
handleResize(mql);